import styled from 'styled-components';
import {
  GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT,
  SYS_COLOR_SURFACE_HIGHLIGHT_PRIMARY_LIGHT,
} from '@oneaudi/unified-web-common';
import { Tag } from '@oneaudi/unified-web-components';

export const StyledCard = styled.div`
  box-sizing: border-box;
  padding: var(--spacing-relative-lg);
  width: 100%;
  max-width: 332px;
  min-width: 285px;
  background-color: ${GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT};
`;

export const StyledCardHeader = styled.div`
  height: 84px;
`;

export const StyledCardHeadingContainer = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const StyledCardImg = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  margin: var(--spacing-relative-sm) 0;
`;

export const StyledGrid = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  align-items: center;
`;

export const StyledNewTag = styled(Tag)`
  background-color: ${SYS_COLOR_SURFACE_HIGHLIGHT_PRIMARY_LIGHT};
  color: ${GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT};
`;

export const StyledButtonWrapper = styled.div`
  padding-block: var(--spacing-relative-lg);
  padding-inline: var(--page-margin);
`;
